// import { generateActions } from "helpers/generateActions";
export const GENERATE_JOB_NUMBER = "GENERATE_JOB_NUMBER";
export const GENERATE_JOB_NUMBER_SUCCESS = "GENERATE_JOB_NUMBER_SUCCESS";
export const API_ERROR = "API_ERROR";

